
const spellColors = {
    Blue: "#0000FF",
    IcyBlue: "#739BD0",
    Red: "#FF0000",
    Gold: "#FFD700",
    Purple: "#A020F0",
    Transparent: "",
    None: "",
    White: "#FFFFFF ",
    Green: "#008000",
    Orange: "#FFA500",
    Yellow: "#FFFF00",
    BrightBlue: "#0096FF",
    Pink: "#FFC0CB",
    Violet: "#7F00FF",
    Scarlet: "#FF2400",
    BlueishWhite: "#dbe9f4",
    Silver: "#C0C0C0",
    FieryScarlet: "#cd212a",
    Grey: "#808080",
    DarkRed: "#8B0000",
    Turquoise: "#40E0D0",
    Fire: "#aa4203 ",
    PsychedelicTransparentWave: "",
    BrightYellow: "#FFEA00",
    BlackSmoke: "#100c08"            
};

export function getSpellColorCode(color) {
    if (spellColors.hasOwnProperty(color)) {
        return spellColors[color];
    } else {
        return "Color not found";
    }
}

export function formatDetail(details) {
    return details && details.length > 0 ? details.join(", ") : 'Unknown';
}

export function handleGoToHomeClickACB() {
    window.location.hash = "#"

}

export function enterQuizClickACB() {
    window.location.hash = "#/quiz";
    props.setPageHandler('Quiz');
}

export function shuffleQuestions(array) {
    const newArray = [...array]
    const length = newArray.length
  
    for (let start = 0; start < length; start++) {
      const randomPosition = Math.floor((newArray.length - start) * Math.random())
      const randomItem = newArray.splice(randomPosition, 1)
  
      newArray.push(...randomItem)
    }
  
    let questions = newArray.slice(0, 10);
    return questions
  }